import styled from 'styled-components';

export const H1 = styled.h1`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: 46px;
  line-height: 58px;
  color: ${({ theme }) => theme.algoanBlue};
  margin: 0;
`;
